var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchLoupe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.19552 15.862L5.74547 11.312C4.86413 10.2233 4.33348 8.84 4.33348 7.33334C4.33348 3.84134 7.1748 1 10.6668 1C14.1587 1 17 3.84131 17 7.33331C17 10.8253 14.1587 13.6667 10.6667 13.6667C9.16009 13.6667 7.77676 13.136 6.68811 12.2547L2.13816 16.8047C2.00816 16.9347 1.83751 17 1.66682 17C1.49614 17 1.32548 16.9347 1.19549 16.8047C0.934833 16.544 0.934833 16.1227 1.19552 15.862ZM10.6667 12.3333C13.424 12.3333 15.6667 10.0907 15.6667 7.33331C15.6667 4.57597 13.424 2.33331 10.6667 2.33331C7.90941 2.33331 5.66678 4.57597 5.66678 7.33331C5.66678 10.0907 7.90944 12.3333 10.6667 12.3333Z",
    fill: "#A5A9B2",
    stroke: "#A5A9B2",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchLoupe);
export default __webpack_public_path__ + "static/media/search_loupe.ba133894c6a732948d9d746fcea660e1.svg";
export { ForwardRef as ReactComponent };